import { db, auth } from './firebase';
import _ from 'lodash';


function baseUrl() { return 'u/' + auth.currentUser.uid }


export const onceGetUsers = () =>
  db.ref(baseUrl() +  '').once('value');


/*Notes*/
export const saveNote = async (symbol, color, note) => {

  var newPostKey = db.ref(baseUrl() +  '/notes/' + symbol).push().key;
  await db.ref(baseUrl() +  '/notes/' + symbol + "/" + newPostKey).set({

    color: color,
    note: note,
    date: new Date().toISOString()
  });
}

export const loadNotes = async (symbol) => {

  const itemsRef = db.ref(baseUrl() +  '/notes/' + symbol);
  let snapshot = await itemsRef.once('value');
  return _.values(snapshot.val());
};

/*Orders*/
export const getOrdersBySymbol = async (symbol) => {

  const itemsRef = db.ref(baseUrl() +  '/orders').orderByChild("symbol").equalTo(symbol);
  let snapshot = await itemsRef.once('value');
  return _.values(snapshot.val());
};
export const getDividendsBySymbol = async (symbol) => {

  const itemsRef = db.ref(baseUrl() +  '/dividends').orderByChild("symbol").equalTo(symbol);
  let snapshot = await itemsRef.once('value');
  return _.values(snapshot.val());
};
export const getOrdersByDate = async (start, end) => {

  const itemsRef = db.ref(baseUrl() +  '/orders').orderByChild("date").startAt(start).endAt(end);
  let snapshot = await itemsRef.once('value');
  return _.values(snapshot.val());
};

export const getPosition = async (symbol) => {

  const itemsRef = symbol ? db.ref(baseUrl() + `/positions/${symbol}`) : db.ref(baseUrl() +  '/positions').orderByChild("quantity");
  let snapshot = await itemsRef.once('value');
  if (symbol) {
    return snapshot.val();
  }
  else {

    return _.values(snapshot.val());
  }
};
export const getOpenPositions = async (symbol) => {

  const itemsRef = db.ref(baseUrl() +  '/positions').orderByChild("quantity").startAt(1);
  let snapshot = await itemsRef.once('value');
  return _.values(snapshot.val());
};
export const getClosedPositions = async (symbol) => {

  const itemsRef = db.ref(baseUrl() +  '/positions').orderByChild("quantity").equalTo(0);
  let snapshot = await itemsRef.once('value');
  return _.values(snapshot.val());
};

export const getCashTransactionsByDate = async (start, end) => {

  const itemsRef = db.ref(baseUrl() +  '/transfers').orderByChild("date").startAt(start).endAt(end);
  let snapshot = await itemsRef.once('value');
  return _.values(snapshot.val());
};



// WEBPACK FOOTER //
// ./src/firebase/db.js